// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightCatalogoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de GET /migration/catalogo/preflight?zoho_id_unidade=...
 * (controllers/migration/catalogo.php::preflight).
 *
 * Diferente das irmas, aqui a franquia e OBRIGATORIA — e isso e limite da
 * ORIGEM, nao escolha de UX: o export global das 9 listas de catalogo estoura
 * o limite de execucao do Creator (HTTP 500, code 9430 — medido em
 * 2026-08-19). Nao existe a forma "todas de uma vez" nesta etapa; a ausencia
 * do campo e recusada na borda com a mensagem que diz o que fazer.
 */
import { registerContract } from './validate'

export interface Migration_PreflightCatalogoInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_PreflightCatalogoInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
